import React 				from 'react';
import ReactDOM 			from 'react-dom';
import ReactJson			from 'react-json-view';
import BLComponent			from '../../core/_BLComponent.jsx';


export default class CategoryLinks extends BLComponent 
{
	constructor ( props, context )
	{
		super( props, context );	// This should come first. 
	}

	componentDidMount() 
	{
	}

	render()
	{
		const {itemType, catNames, catIds, catString} = this.props.data;
		let categoryList = [];

		if (typeof catNames == "undefined") return null;

		for (var i = 0; i < catNames.length; i++ )
		{
			categoryList[i] = { catName: catNames[i], catId: catIds[i] };
		}
		
		const categoryListView = categoryList.map( (category, idx) => {
			const categoryUrl = "/catalogList.asp?catType=" + itemType + "&catString=" + catString;
			const catName = blapp.util.decodeHtml(category.catName);
			return (
				<React.Fragment key={"catID-" + category.catId + "-" + idx}>
					{catName} {(idx != (catNames.length - 1))&&<span>:&nbsp;</span>}
				</React.Fragment>
			)


		} );


		return(
			<div>
				{categoryListView}
			</div>

		)
	}
}